import { Stack, Typography, Divider } from '@mui/material';

import { SupportedResourceTypesText } from '@/app/(dashboard)/settings/backup-policies/supportedResourceTypesText';

import { ZERO_ETL_SUPPORTED_RESOURCE_TYPES } from './zeroEtlPolicyTypes';

export const ZeroEtlDisclaimer = () => {
  return (
    <>
      <Stack gap='2px'>
        <div />
        <Stack
          alignItems='center'
          className='bg-[var(--mui-palette-background-section)]'
        >
          <ZeroEtlDescription />
        </Stack>
        <Divider />
      </Stack>
    </>
  );
};

const ZeroEtlDescription = () => {
  return (
    <Typography padding='12px 0px'>
      {`AWS Glue integration. Available for `}
      <SupportedResourceTypesText
        resourceTypes={ZERO_ETL_SUPPORTED_RESOURCE_TYPES}
      />
    </Typography>
  );
};
